import { connect } from "react-redux";
import ListAnalyticsProfilesComponent from "../../Components/Dashboard/Analytics/ListAnalyticsProfilesComponent";
import { setAnalyticsProfiles } from "../../Redux/Actions/AnalyticsActions";

const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  ANALYTICS_PROFILES: state.reducer.ANALYTICS_PROFILES,
});

const mapDispatchToProps = {
  setAnalyticsProfiles,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListAnalyticsProfilesComponent);
